document.documentElement.classList.add('js');
document.addEventListener('change', event => {
  const select = event.target.closest('[data-option-select]');
  if (!select) return;
  const section = select.closest('[data-product-section]');
  if (!section) return;
  const data = JSON.parse(section.querySelector('[data-product-json]').textContent);
  const selections = [...section.querySelectorAll('[data-option-select]')].map(input => input.value);
  const variant = data.variants.find(item => item.options.every((value, index) => value === selections[index]));
  const idInput = section.querySelector('[name="id"]');
  const price = section.querySelector('[data-product-price]');
  const button = section.querySelector('[data-add-to-cart]');
  if (!variant) {
    button.disabled = true;
    return;
  }
  idInput.value = variant.id;
  price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: section.dataset.currency }).format(variant.price / 100);
  button.disabled = !variant.available;
  button.textContent = variant.available ? button.dataset.availableText : button.dataset.soldOutText;
});
document.addEventListener('submit', async event => {
  const form = event.target.closest('[data-product-form]');
  if (!form || !window.fetch) return;
  event.preventDefault();
  const button = form.querySelector('[data-add-to-cart]');
  button.disabled = true;
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('cart');
    window.location.href = window.Shopify.routes.root + 'cart';
  } catch {
    form.submit();
  }
});
document.addEventListener('submit', event => {
  const form = event.target.closest('[data-collection-filter-form]');
  if (!form) return;
  event.preventDefault();
  const destination = form.querySelector('[data-collection-filter]')?.value;
  if (destination) window.location.assign(destination);
});
document.addEventListener('click', event => {
  const opener = event.target.closest('[data-product-image-open]');
  if (opener) {
    const dialog = document.querySelector('[data-product-image-dialog]');
    const image = dialog?.querySelector('[data-product-image-dialog-image]');
    if (!dialog || !image) return;
    image.src = opener.dataset.imageSrc;
    image.alt = opener.dataset.imageAlt;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    dialog.addEventListener('close', () => opener.focus(), { once: true });
    return;
  }
  const closeButton = event.target.closest('[data-product-image-close]');
  if (closeButton) {
    const dialog = closeButton.closest('[data-product-image-dialog]');
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    return;
  }
  const dialog = event.target.closest('[data-product-image-dialog]');
  if (dialog && event.target === dialog) dialog.close();
});
